"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_demi_1 = require("vue-demi");
const util_1 = require("../util");
const useHeaderHorizScroll_1 = require("../composables/useHeaderHorizScroll");
const useHeaderFixed_1 = require("../composables/useHeaderFixed");
const useViewport_1 = require("../composables/useViewport");
const useHeaderActive_1 = require("../composables/useHeaderActive");
const request_1 = tslib_1.__importDefault(require("../assets/scripts/request"));
const rateByApp_1 = require("../assets/rateByApp");
const conf_1 = require("../assets/conf");
const __sfc_main = {};
__sfc_main.props = ['list', 'defaultRateCol', 'tabTheme', 'pickColor', 'pickBgColor', 'normalColor', 'normalBgColor', 'fixedType', 'pickBtColor', 'tabShowType', 'listOnlyTitle'];
__sfc_main.setup = (__props, __ctx) => {
    const { isPreRender } = require('../util');
    const { useToast, useLang } = require('@fegobull/webapi').use;
    const { store: { cmp } } = require('@futuweb/fego-render');
    const props = __props;
    const { langText } = useLang();
    const Toast = useToast();
    const tradeIdeaRef = (0, vue_demi_1.ref)(null);
    const tradeIdeTabReal = (0, vue_demi_1.ref)(null);
    const tradeIdeTabFaker = (0, vue_demi_1.ref)(null);
    const rateColorCls = (0, rateByApp_1.useRateClsByApp)(true, props.defaultRateCol || 'reddown');
    const dataList = (0, vue_demi_1.ref)([]);
    const baseInfo = {};
    if (props.tabShowType === conf_1.TAB_SHOW_TYPE.ONLY_TITLE) {
        dataList.value = [...props.listOnlyTitle];
    }
    else {
        props.list.forEach(item => {
            dataList.value.push(Object.assign(Object.assign({}, item), { miuns: false, rate: '---' }));
            baseInfo[`stock_${item.stockId}`] = {
                rate: 0,
                price: '0.000'
            };
        });
    }
    const vm = window.FEGORender.store.variable;
    vm.$set(vm.data, 'baseInfo', baseInfo);
    const { shouldScroll, scrollNavToHorizCenter } = (0, useHeaderHorizScroll_1.useHeaderHorizScroll)({
        tradeIdeaRef,
        props
    });
    const { current } = (0, useHeaderActive_1.useHeaderActive)({
        tradeIdeaRef,
        list: dataList.value
    }, {
        onItemRenderChange: () => {
            scrollNavToHorizCenter();
        }
    });
    const { viewportWidth } = (0, useViewport_1.useViewport)();
    (0, useHeaderFixed_1.useHeaderFixed)({
        tradeIdeaRef,
        fixedType: props.fixedType
    });
    const clickMe = ({ target }) => {
        if (!target) {
            return;
        }
        const vmEl = cmp.getVmById(target);
        if (!vmEl) {
            return;
        }
        // 偏移量
        const offset = 0 - (tradeIdeTabReal.value.offsetHeight || 0);
        try {
            (0, util_1.scrollToElement)(vmEl.$el, {
                offset
            });
        }
        catch (err) {
            console.error('=======clickMe-err=======', err);
        }
    };
    //获取股票实时价格
    const getStockPrice = async (stockArr) => {
        const HUNDRED = 100;
        const FIXED_NUM = 2;
        const PRICE_UNIT = 1e9;
        const PRICE_UNIT1 = 1e3;
        const stockIds = stockArr.filter(item => item);
        if (!stockIds.length) {
            return;
        }
        const res = await request_1.default.getStockPrice({
            stockIds: stockIds.join(',')
        });
        const retMap = {};
        (res || []).forEach(item => {
            const { currentPrice, lastClosePrice } = item;
            // 涨跌幅 = (当前价格 - 历史收盘价) / 历史收盘价
            const quoteChangeNum = Number(lastClosePrice) ? (currentPrice - lastClosePrice) / lastClosePrice : 0;
            const minus = currentPrice - lastClosePrice < 0;
            let rate = '---';
            if (Number(lastClosePrice)) {
                rate = minus ? `${(quoteChangeNum * HUNDRED).toFixed(FIXED_NUM)}%` : `+${(quoteChangeNum * HUNDRED).toFixed(FIXED_NUM)}%`;
            }
            retMap[item.stockId] = {
                price: currentPrice ? Math.round(currentPrice * PRICE_UNIT1 / PRICE_UNIT) / PRICE_UNIT1 : 0,
                //实时价格 精度元,放大1e9
                minus,
                rate
            };
        });
        return retMap;
    };
    //获取股票实时价格
    const getStockInfo = async () => {
        if (props.tabShowType === conf_1.TAB_SHOW_TYPE.ONLY_TITLE) {
            return;
        }
        const stockIds = props.list.filter(item => item.stockId && !item.hideRate).map(item => item.stockId);
        if (!stockIds.length) {
            Toast.msg('参数异常');
            return;
        }
        let retMap = {};
        if (stockIds.length) {
            const res = await getStockPrice(stockIds);
            retMap = Object.assign({}, res);
        }
        dataList.value.forEach(item => {
            const { stockId } = item;
            if (retMap[stockId]) {
                const { rate, minus, price } = retMap[stockId];
                baseInfo[`stock_${stockId}`] = {
                    rate: rate,
                    price: price
                };
                item.rate = rate;
                item.minus = minus;
            }
        });
        vm.$set(vm.data, 'baseInfo', baseInfo);
    };
    // 当前激活标题发生变化
    (0, vue_demi_1.watch)(() => current.value || shouldScroll.value, () => {
        if (isPreRender()) {
            return;
        }
        // 横向滚动到当前激活标题
        scrollNavToHorizCenter();
    }, {
        immediate: true
    });
    // 视口变化
    (0, vue_demi_1.watch)(() => viewportWidth.value, () => {
        (0, vue_demi_1.nextTick)(() => {
            // 更新下划线
            if (isPreRender()) {
                return;
            }
            // 变更 header-real 的 max-width 值，否则 fixed 时会超出 750
            const tradeIdeaTab = tradeIdeaRef.value;
            const tradeIdeaTabRealHeader = tradeIdeTabReal.value;
            const maxWidth = `${tradeIdeaTab.getBoundingClientRect().width}px`;
            tradeIdeaTabRealHeader.style.maxWidth = maxWidth;
        });
    }, {
        immediate: true
    });
    (0, vue_demi_1.onMounted)(async () => {
        await getStockInfo();
    });
    return {
        langText,
        tradeIdeaRef,
        tradeIdeTabReal,
        tradeIdeTabFaker,
        rateColorCls,
        dataList,
        shouldScroll,
        current,
        clickMe
    };
};
exports.default = __sfc_main;
//# sourceMappingURL=data:application/json;base64,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